import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-hot-toast';

const ProtectedRoute = ({ children, requiredPermission, requiredRole }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const hasShownError = useRef(false);

  // Permission ve role kontrolü için değişken
  let shouldRedirect = false;

  // Permission kontrolü
  if (requiredPermission && user) {
    const permissions = user?.permissions || {};
    
    // Superadmin her zaman tüm yetkilere sahip
    if (user.role !== 'superadmin') {
      if (permissions[requiredPermission] === false) {
        // Permission false ise erişim yok
        shouldRedirect = true;
      } else if (permissions[requiredPermission] === undefined) {
        // Permission undefined ise güvenlik için erişim vermeyelim
        shouldRedirect = true;
      }
    }
  }

  // Role kontrolü
  if (requiredRole && user?.role !== requiredRole) {
    shouldRedirect = true;
  }

  // Hata mesajını göster (sadece bir kez)
  useEffect(() => {
    if (shouldRedirect && !hasShownError.current && !loading && isAuthenticated) {
      toast.error('You do not have permission to access this page');
      hasShownError.current = true;
    }
  }, [shouldRedirect, loading, isAuthenticated]);

  // Loading durumunda spinner göster
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Giriş yapmamışsa login sayfasına yönlendir
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Yetkisi yoksa dashboard'a yönlendir
  if (shouldRedirect) {
    return <Navigate to="/" replace />;
  }

  // Giriş yapmış ve yetkisi varsa içeriği göster
  return children;
};

export default ProtectedRoute; 